/* eslint-disable no-param-reassign */
import axios from "axios";
import { $toast } from "vuetify-snackbar-toast";
import router from "@/router";
import authService from "@/Services/AuthService";

function getCsrfToken() {
  const cookieList = document.cookie.split(";").filter((str) => str.includes("csrftoken"));
  if (cookieList.length > 0) {
    const cookie = cookieList[0].replace("csrftoken=", "").trim();
    return cookie;
  }
  return null;
}

function getResponseMessage(data, fallback) {
  return data?.message || data?.error?.message || fallback;
}

export default () => {
  const options = { baseURL: process.env.VUE_APP_API_HOST };
  const axiosInstance = axios.create(options);
  axiosInstance.interceptors.request.use((config) => {
    const token = authService.getAccessToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    const csrfToken = getCsrfToken();
    if (csrfToken) config.headers["X-CSRF-TOKEN"] = csrfToken;
    return config;
  });
  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401 && authService.getAccessToken()) {
        $toast.warn("Sua sessão expirou");
        const currentRouteName = router.currentRoute.name;
        if (currentRouteName !== "login" && currentRouteName !== "logout") {
          router.push({ name: "logout" });
        }
        return Promise.reject(new Error("Sua sessão expirou"));
      }
      if (error.response && error.response.status === 403) {
        const message = getResponseMessage(
          error.response.data,
          "Você não tem permissão para acessar esse recurso."
        );
        return Promise.reject(new Error(message));
      }
      if (error.response && error.response.status === 404) {
        if (error.response.data instanceof ArrayBuffer) {
          try {
            const decoded = JSON.parse(new TextDecoder("utf-8").decode(error.response.data));
            const message =
              decoded.message ||
              decoded.error?.message ||
              "Nenhum registro encontrado para o item pesquisado.";
            return Promise.reject(new Error(message));
          } catch (e) {
            return Promise.reject(new Error("Nenhum registro encontrado para o item pesquisado."));
          }
        } else {
          const message = getResponseMessage(
            error.response.data,
            "Nenhum registro encontrado para o item pesquisado."
          );
          return Promise.reject(new Error(message));
        }
      }
      if (error.response && error.response.status === 400) {
        const message = getResponseMessage(
          error.response.data,
          "Nenhum registro encontrado para o item pesquisado."
        );
        return Promise.reject(new Error(message));
      }

      // if (error.response && error.response.status === 500) {
      //   return Promise.reject(new Error(error.response.data.error.message));
      // }
      if (error.response) {
        return Promise.reject(error.response.data);
      }
      return Promise.reject(error);
    }
  );
  return axiosInstance;
};
